module.exports = __webpack_public_path__ + "static/media/plus-inex.b044dbaa.svg";